<template>
  <div>
    <LgImgsSection
      v-if="!!images.before && images.before.length"
      :title="t('beforeService')"
      :imgs="images.before"
      test-id="long_grass_job_images_section-before_service"
    />

    <LgImgsSection
      v-if="!!images.after && images.after.length"
      :title="t('afterService')"
      :imgs="images.after"
      class="afterService"
      test-id="long_grass_job_images_section-after_service"
    />
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import LgImgsSection from './LgImgsSection.vue';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'LgJobImagesSection',
  components: { LgImgsSection },
  mixins: [themedComponentMixin],
  props: {
    images: VueTypes.shape({
      before: VueTypes.arrayOf(
        VueTypes.shape({
          id: VueTypes.number,
          src: VueTypes.string,
          thumbSrc: VueTypes.string,
          caption: VueTypes.string,
        }).loose
      ),
      after: VueTypes.arrayOf(
        VueTypes.shape({
          id: VueTypes.number,
          src: VueTypes.string,
          thumbSrc: VueTypes.string,
          caption: VueTypes.string,
        }).loose
      ),
    }).loose,
  },
};
</script>

<style lang="scss" scoped>
div {
  padding: 3rem 0;
  border-top: 1px solid $theme-color-primary-light;
}
.afterService {
  padding-top: 3rem;
}
</style>
